import { render, staticRenderFns } from "./TypeOfPurchaseOrdersMainChart.vue?vue&type=template&id=3779c1ad&scoped=true&"
import script from "./TypeOfPurchaseOrdersMainChart.vue?vue&type=script&lang=js&"
export * from "./TypeOfPurchaseOrdersMainChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3779c1ad",
  null
  
)

export default component.exports